import type { ChatSource } from "@mirage/mosaics/Chat/types";
import { useCallback, useState } from "react";

interface UseSourcesFilterProps {
  onFilterChange?: (appTypes: Set<string>) => void;
  onMenuOpen?: (isOpen: boolean) => void;
}

interface UseSourcesFilterResult {
  selectedAppTypes: Set<string>;
  handleAppTypeSelect: (appTypes: Set<string>) => void;
  handleFilterMenuOpen: (isOpen: boolean) => void;
  matchesFilter: (source: ChatSource, appTypes: Set<string>) => boolean;
}

export const useSourcesFilter = ({
  onFilterChange,
  onMenuOpen,
}: UseSourcesFilterProps): UseSourcesFilterResult => {
  const [selectedAppTypes, setSelectedAppTypes] = useState<Set<string>>(
    new Set(),
  );

  const handleAppTypeSelect = useCallback(
    (appTypes: Set<string>) => {
      setSelectedAppTypes(appTypes);
      onFilterChange?.(appTypes);
    },
    [onFilterChange],
  );

  const matchesFilter = useCallback(
    (source: ChatSource, appTypes: Set<string>): boolean => {
      if (appTypes.size === 0) return true;

      const connectorName =
        source.type === "dash_search_result"
          ? source.searchResult.connector_info?.connector_name
          : source.type === "recommendation"
            ? source.recommendation.connectorInfo?.connectorName
            : undefined;

      return connectorName !== undefined && appTypes.has(connectorName);
    },
    [],
  );

  return {
    selectedAppTypes,
    handleAppTypeSelect,
    handleFilterMenuOpen: onMenuOpen ?? (() => {}),
    matchesFilter,
  };
};
